import { useRecoilValue } from 'recoil';
import { navigationTranslationState } from 'store';
import { Stack, Typography, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { AnimatedTeleportButton } from './TeleportButton';
import { TeleportGroupType } from './NavigationWrapper';

export const TeleportOverlay = ({
  setShowTeleportLoading,
  endTeleportName,
  rtl,
  endTpType,
}: {
  rtl?: boolean;
  setShowTeleportLoading: (val) => void;
  endTeleportName: string;
  endTpType: TeleportGroupType;
}) => {
  const [progressValue, setProgressValue] = useState(0);
  const translation = useRecoilValue(navigationTranslationState);

  useEffect(() => {
    const totalTime = 3000; // Total time to fill the progress bar
    const updateInterval = 100; // How often to update the progress (in milliseconds)
    const incrementValue = 100 / (totalTime / updateInterval); // Calculate the increment value per update to reach 100% in 3 seconds

    const interval = setInterval(() => {
      setProgressValue((prev) => {
        const nextValue = prev + incrementValue;
        if (nextValue >= 100) {
          clearInterval(interval);
          // As soon as we reach 100, we might want to hide the progress bar or reset it
          setTimeout(() => {
            setShowTeleportLoading(false);
          }, 500);
          return 100; // Ensure we don't exceed 100%
        }
        return nextValue;
      });
    }, updateInterval);

    return () => {
      clearInterval(interval);
      setProgressValue(0); // Reset progress bar when the component unmounts or the effect is re-run
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack
      id="teleport-overlay"
      position="relative"
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
      zIndex={9999}
    >
      <Box
        component="img"
        src={
          endTpType === TeleportGroupType.Elevator
            ? '/navigation/elevator.png'
            : '/navigation/stairway.png'
        }
        alt="elevator"
        width="100vw"
        height="100vh"
        position="relative"
        zIndex={1100}
      />
      <Stack
        position="absolute"
        width="100vw"
        height="100vh"
        sx={{
          backdropFilter: 'blur(8px)',
        }}
        zIndex={1101}
      />
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1102,
        }}
      >
        <AnimatedTeleportButton progressValue={progressValue} endTpType={endTpType} />
        {endTeleportName && (
          <>
            <Typography
              fontSize="24px"
              fontWeight={400}
              sx={{ color: '#fff', direction: rtl ? 'rtl' : 'ltr' }}
            >
              {translation?.navMovingTo || 'Moving to'}
            </Typography>
            <Typography
              fontSize="35px"
              fontWeight={600}
              sx={{ color: '#fff', direction: rtl ? 'rtl' : 'ltr' }}
            >
              {endTeleportName}
            </Typography>
          </>
        )}
      </Stack>
    </Stack>
  );
};
